<template>
  <div class="relative selection:bg-[#ecd79f] selection:text-[#1c4848]">
    <div
      class="fixed inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03] pointer-events-none z-50"
    ></div>

    <HomeHeader />
    <HomeHero />
    <HomeQuranStudy />
    <HomeWhatIsDeenly />
    <HomeBentoFeatures />
    <HomeKidsSection />
    <HomeFaq />
    <HomeCtaFooter />
  </div>
</template>

<script setup>
import HomeHeader from '@/components/home/HomeHeader.vue';
import HomeHero from '@/components/home/HomeHero.vue';
import HomeQuranStudy from '@/components/home/HomeQuranStudy.vue';
import HomeWhatIsDeenly from '@/components/home/HomeWhatIsDeenly.vue';
import HomeBentoFeatures from '@/components/home/HomeBentoFeatures.vue';
import HomeKidsSection from '@/components/home/HomeKidsSection.vue';
import HomeFaq from '@/components/home/HomeFaq.vue';
import HomeCtaFooter from '@/components/home/HomeCtaFooter.vue';
import { usePageMeta } from '@/composables/usePageMeta';
import { buildJsonLd, meta } from '@/seo/siteContent.js';

// Coming back from a Quran page, the head must describe the home page again.
usePageMeta(() => ({ ...meta, path: '/', jsonLd: buildJsonLd() }));
</script>
